
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import AsyncSelect from 'react-select/async';

function SupplierOutstandingReport() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [selectedOption, setSelectedOption] = useState('itemWise');
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customerId, setCustomer] = useState('');
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
        //fetchCustomerData();
    }, [isAuthenticated, companyId, token, branchId, logout]);

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    // Supplier
    const [SupplierTypeOptions, setSupplierTypeOptions] = useState([]);
    const [selectedSupplierType, setSelectedSupplierType] = useState("");
    const [selectedSupplier, setSupplierType] = useState("0");

    const fetchSupplierType = async () => {
        try {

            const response = await fetchData('SupplierApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(spr => ({
                    value: spr.id,
                    label: spr.name
                }));
                setSupplierTypeOptions(options);
            }

        } catch (error) {
            console.error('Error fetching  Supplier Type:', error);
        }
    };

    const handleCustomerTypeChange = (selectedOption) => {
        setSelectedSupplierType(selectedOption);
        setSupplierType(selectedOption.value);
    };

    useEffect(() => {
        fetchSupplierType();
    }, []);

    const fetchTableData = async () => {
        const branchId = 0;
        setDataItem([])
        try {
            const response = await fetchData('ReportApi', `/SupplierOutstanding/${companyId}/${selectedSupplier}/${branchId}`, token);
            if (response.responseCode === '1111') {
                setDataItem(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Supplier Details:', error);
        }
    };

    const hasReadReportPermission = permissions.includes('Read Reports');

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataBill = dataBill.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    const handleExportExcel = () => {
        const excelData = [];
    
        // Header Caption
        const headerCaption = [`Supplier Outstanding From : ${formatDate(fromDate)} To : ${formatDate(toDate)}`];
        excelData.push(headerCaption);
        excelData.push([]); // Empty row for spacing
    
        const headerRow = ['Supplier','Bill Number', 'Bill Date', 'Bill Amount', 'Paid Amount', 'Balance Amount', 'Due Days'];
        excelData.push(headerRow);
    
        // Group by SupplierName
        let totalPurchase = 0;
        let totalPaid = 0;
        let totalBalance = 0;
    
        let previousSupplier = null;
    
        filteredDataItem.forEach((rowData) => {
            const {
                SupplierName,
                BillNumber,
                BillDate,
                PurchaseAmount,
                PaidAmount,
                BalanceAmount,
                DueDays
            } = rowData;
    
            // Insert Supplier Name row when it's new
            if (SupplierName !== previousSupplier) {
                excelData.push([`${SupplierName}`]);
                previousSupplier = SupplierName;
            }
    
            // Push bill row
            excelData.push([
                '', // Name is empty since SupplierName is already printed above
                BillNumber,
                formatDate(BillDate),               
                PurchaseAmount,
                PaidAmount,
                BalanceAmount,
                DueDays
            ]);
    
            // Update totals
            totalPurchase += Number(PurchaseAmount || 0);
            totalPaid += Number(PaidAmount || 0);
            totalBalance += Number(BalanceAmount || 0);
        });
    
        // Empty row before total
        excelData.push([]);
    
        // Total row
        const totalRow = ['TOTAL', '', '', totalPurchase.toFixed(2), totalPaid.toFixed(2), totalBalance.toFixed(2), ''];
        excelData.push(totalRow);
    
        // Export to Excel
        const ws = XLSX.utils.aoa_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Supplier Details');
        XLSX.writeFile(wb, 'Supplier_Details.xlsx');
    };
    

    const headerCellStyle = {
        textTransform: 'uppercase',
        backgroundColor: '#EFEEEA',
        borderBottom: '1px solid #ddd',
        fontSize: '12px',
        color: 'black',
        padding: '5px',
        fontWeight: 'bold',
    };

    const cellStyle = {
        borderBottom: '1px solid black',
        color: 'black',
        fontWeight: 'bolder',
        padding: '7px',
        fontSize: '12px',
    };


    return (
        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>

            <h6
                className="uppercase tracking-wide text-black font-serif flex-grow"
                style={{
                    fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',
                    color: 'black',
                    marginTop: '10px',
                }}
            >
                Supplier Outstanding
            </h6>

            <div style={{ display: 'flex', flexWrap: 'nowrap', marginBottom: '16px', marginLeft: '2px', marginTop: '1.25%' }}>

                <div className="w-1/2 mr-2">

                    <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                        Supplier
                    </label>

                    <Select
                        value={selectedSupplierType}
                        onChange={handleCustomerTypeChange}
                        options={SupplierTypeOptions}
                        placeholder="Select Supplier"
                        styles={{
                            menu: (provided) => ({
                                ...provided,
                                zIndex: 1301,
                            }),
                            control: (provided) => ({
                                ...provided,
                                //  width: '350px',
                            }),
                        }}
                        isSearchable
                    />

                </div>

                <Button
                    // style={{ marginLeft: '8px', color: 'darkgreen' }}
                    style={{
                        background: 'linear-gradient(to right, #A8A196,#A8A196)',
                        color: 'black',
                        fontWeight: 'bolder',
                        textTransform: 'none',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                        maxHeight: '30px',
                        //marginLeft: '5px',
                        marginLeft: '15px',
                        marginTop: '1.5%'

                    }}
                    onClick={fetchTableData}

                >
                    <RefreshIcon style={{ color: 'white', fontWeight: 'bolder' }} />
                    <b style={{ color: 'white' }}>Refresh</b>
                </Button>

                <Button
                    // style={{ marginLeft: '8px', color: 'darkgreen' }}
                    style={{
                        background: 'linear-gradient(to right, #4D455D,#4D455D)',
                        color: 'black',
                        fontWeight: 'bolder',
                        textTransform: 'none',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                        maxHeight: '30px',
                        //marginLeft: '5px',
                        marginLeft: '15px',
                        marginTop: '1.5%'

                    }}
                    onClick={handleExportExcel}

                >
                    <FeedIcon style={{ color: 'white', fontWeight: 'bolder' }} />
                    <b style={{ color: 'white' }}>Excel</b>
                </Button>
            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '510px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={headerCellStyle}>Supplier</TableCell>
                                <TableCell sx={headerCellStyle}>Bill Number</TableCell>
                                <TableCell sx={headerCellStyle}>Bill Date</TableCell>
                                <TableCell sx={{ ...headerCellStyle, textAlign: 'right' }}>Bill Amount</TableCell>
                                <TableCell sx={{ ...headerCellStyle, textAlign: 'right' }}>Paid Amount</TableCell>
                                <TableCell sx={{ ...headerCellStyle, textAlign: 'right' }}>Balance Amount</TableCell>
                                <TableCell sx={{ ...headerCellStyle, textAlign: 'right' }}>Due Days</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {(() => {
                                let previousSupplier = null;

                                return filteredDataItem.map((data) => {
                                    const showSupplier = data.SupplierName !== previousSupplier;
                                    previousSupplier = data.SupplierName;

                                    return (
                                        <TableRow
                                            key={data.id}
                                            className={data.routeName === 'Total' ? 'highlighted-row' : ''}
                                            sx={{
                                                padding: '7px',
                                                height: '40px',
                                                backgroundColor: data.routeName === 'Total' ? 'teal' : 'transparent',
                                            }}
                                        >
                                            <TableCell sx={{ ...cellStyle, textAlign: 'left' }}>
                                                {showSupplier ? data.SupplierName : ''}
                                            </TableCell>
                                            <TableCell sx={{ ...cellStyle, textAlign: 'left' }}>{data.BillNumber}</TableCell>
                                            <TableCell sx={{ ...cellStyle, textAlign: 'left' }}>{formatDate(data.BillDate)}</TableCell>
                                            <TableCell sx={{ ...cellStyle, textAlign: 'right' }}>{data.PurchaseAmount}</TableCell>
                                            <TableCell sx={{ ...cellStyle, textAlign: 'right' }}>{data.PaidAmount}</TableCell>
                                            <TableCell sx={{ ...cellStyle, textAlign: 'right' }}>{data.BalanceAmount}</TableCell>
                                            <TableCell sx={{ ...cellStyle, textAlign: 'right' }}>{data.DueDays}</TableCell>
                                        </TableRow>
                                    );
                                });
                            })()}

                            {/* Total Row */}
                            <TableRow sx={{ backgroundColor: '#EDDFE0' }}>
                                <TableCell colSpan={3} sx={{ ...cellStyle, fontWeight: 'bold' }}>TOTAL</TableCell>
                                <TableCell sx={{ ...cellStyle, textAlign: 'right', fontWeight: 'bold' }}>
                                    {filteredDataItem.reduce((sum, item) => sum + Number(item.PurchaseAmount || 0), 0).toFixed(2)}
                                </TableCell>
                                <TableCell sx={{ ...cellStyle, textAlign: 'right', fontWeight: 'bold' }}>
                                    {filteredDataItem.reduce((sum, item) => sum + Number(item.PaidAmount || 0), 0).toFixed(2)}
                                </TableCell>
                                <TableCell sx={{ ...cellStyle, textAlign: 'right', fontWeight: 'bold' }}>
                                    {filteredDataItem.reduce((sum, item) => sum + Number(item.BalanceAmount || 0), 0).toFixed(2)}
                                </TableCell>
                                <TableCell sx={{ ...cellStyle }} />
                            </TableRow>

                        </TableBody>
                    </Table>
                </TableContainer>
            </div>

        </div>
    );
}

export default SupplierOutstandingReport;
